var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30803 6.39453L0.385205 1.68715C-0.0490133 1.16609 0.321512 0.375 0.999782 0.375L8.00038 0.375C8.67865 0.375 9.04918 1.16609 8.61496 1.68715L4.69214 6.39453C4.59219 6.51447 4.40798 6.51447 4.30803 6.39453Z",
    fill: "#9367D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleArrowDown);
export default __webpack_public_path__ + "static/media/PurpleArrowDown.fef3c6f76dc8cc4033d1c32bceb4ca84.svg";
export { ForwardRef as ReactComponent };